import {
  type ConfirmPaymentResponse,
  type FetchPendingPaymentResponse,
  type Guard,
} from './sweetpass-checkout.machine.types';

// ─── Pending payment ─────────────────────────────────────────────────────────

const checkIfHasPendingPayment: Guard<FetchPendingPaymentResponse> = (_args, params) => {
  return params.hasPendingPayment;
};

// ─── Confirm payment ─────────────────────────────────────────────────────────

const checkIfPaymentConfirmed: Guard<ConfirmPaymentResponse> = (_args, params) => {
  return params.result === 'confirmed';
};

const checkIfAlreadyPurchased: Guard<ConfirmPaymentResponse> = (_args, params) => {
  return params.result === 'already-purchased';
};

const checkIfPaymentCanceled: Guard<ConfirmPaymentResponse> = (_args, params) => {
  return params.result === 'canceled';
};

// ─────────────────────────────────────────────────────────────────────────────

export const Guards = {
  checkIfHasPendingPayment,
  checkIfPaymentConfirmed,
  checkIfAlreadyPurchased,
  checkIfPaymentCanceled,
};
